export function extractFilename(fileUrl: string): string {
  try {
    const url = new URL(fileUrl);
    const pathname = url.pathname;
    return decodeURIComponent(
      pathname.substring(pathname.lastIndexOf("/") + 1)
    );
  } catch {
    // If not a valid URL, fallback to last segment
    return decodeURIComponent(fileUrl.split("/").pop() || "file");
  }
}
